import { useEffect } from "react";
import { NativeModules, Platform } from "react-native";
import { useNavigation } from "@react-navigation/native";
import { getInitialURL, parse } from "expo-linking";
import { addEventListener as linkingAddEventListener } from "expo-linking";
import { nativeNavFromSlug } from "../components/Promotion/Utils";
import { fetchPost } from "../client";
import useRefreshUser from "./useRefreshUser";

const getToken = async (type: "free" | "paid" = "paid") => {
  const email = `${type}@onpacegroup.com`;
  const resp = await fetchPost(
    "member/authentication/login",
    {},
    { username: email, password: "abcDEF123!" }
  );

  return resp.jwt_token;
};

const useDeepLink = () => {
  const navigation = useNavigation();
  const { refreshUser } = useRefreshUser();

  useEffect(() => {
    if (Platform.OS === "web") return;

    const handleDeepLink = async (event) => {
      console.log(`[DeepLink] Received Deep Link:: ${JSON.stringify(event)}`);
      let data = parse(event.url);
      if (data.path) {
        const { screen, paramsObj } = nativeNavFromSlug(data.path);
        navigation?.navigate(screen, paramsObj);
      }
      if (data?.queryParams?.action === "login") {
        const accountType = data?.queryParams?.accountType || "paid";
        const jwtToken = await getToken(accountType);
        refreshUser(jwtToken);
      }
    };

    // Check if the app was opened by a deep link
    getInitialURL().then((url) => {
      if (url) handleDeepLink({ url });
    });

    // Listen for incoming links
    const urlEventListener = linkingAddEventListener("url", handleDeepLink);

    // Cleanup the event listener
    return () => {
      urlEventListener.remove();
    };
  }, [navigation]);
};

export default useDeepLink;
